/**
 * Rutas y textos compartidos del embudo membresía → cuenta → aprobación → acceso.
 * Mantiene coherencia entre portal, registro, pendiente y mi-acceso.
 *
 * Orden del embudo (post-pago):
 *   PORTAL_REGISTRO → PORTAL_COMPLETAR_REGISTRO → PENDING_APPROVAL → MI_ACCESO
 * ENTRAR = sesión existente sin alta de membresía en curso.
 *
 * MI_ACCESO canónico vive bajo /portal/mi-acceso (link de acceso asignado).
 * /mi-acceso redirige al canónico por compatibilidad.
 */

export const MEMBERSHIP_ACCESS_PORTAL_PATH = "/portal-acceso";

/** Rutas del embudo público (única fuente para Router y redirects). */
export const MEMBERSHIP_ROUTE = {
  REGISTRO: "/registro",
  /** Alias canónico post-pago: misma vista que REGISTRO pero bajo la URL del portal. */
  PORTAL_REGISTRO: "/portal/registro",
  COMPLETAR_REGISTRO: "/completar-registro",
  /** Alias portal del paso de perfil post-Clerk (misma vista que COMPLETAR_REGISTRO). */
  PORTAL_COMPLETAR_REGISTRO: "/portal/completar-registro",
  PENDING_APPROVAL: "/pending-approval",
  /**
   * Link de acceso asignado (Telegram, etc.).
   * Canónico bajo el portal: el fan se queda en /portal/* con su link.
   */
  MI_ACCESO: "/portal/mi-acceso",
  /** Legacy path — App redirige a MI_ACCESO. */
  MI_ACCESO_LEGACY: "/mi-acceso",
  ENTRAR: "/entrar",
} as const;

export type MembershipFunnelPath = (typeof MEMBERSHIP_ROUTE)[keyof typeof MEMBERSHIP_ROUTE];

/** Texto del enlace secundario repetido en las pantallas del embudo. */
export const MEMBERSHIP_PORTAL_LINK_TEXT = "Guía de pasos de acceso";

